module.exports = __webpack_public_path__ + "static/img/map-3.17f79a96.png";